import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import Numeral from 'numeral';
import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom";
import Slider from "react-slick";
import { startFetchVehicleDetails } from '../actions/vehicleAds'
import Loading from '../components/Loading';
import { enToFa } from '../utils/NumberUtility'
import logo from '../assets/images/C_logo.png';
import {
    startAddVehicleToFavourites,
    startRemoveVehicleFromFavourites,
    startReportVehicleAd
} from '../actions/vehicleAds'
import ModalComponent from '../components/ModalComponent';

const VehicleDetails = (props) => {

    const [isLoading, setLoading] = useState(true);
    const [isFavoured, setFavoured] = useState(false);
    const [reportDialog, setReportDialog] = useState(false);
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setViewerOpen] = useState(false);
    const [slideImages, setSlideImages] = useState(undefined);
    const imgRef = useRef();
    const onUpdate = useCallback(({ x, y, scale }) => {
        const { current: img } = imgRef;

        if (img) {
            const value = make3dTransformValue({ x, y, scale });

            img.style.setProperty("transform", value);
        }
    }, []);


    const detailKeys = [
        { key: "specialCategory", translation: 'نوع کاربری' },
        { key: "yearModel", translation: 'سال ساخت' },
        { key: "bodyColor", translation: 'رنگ بدنه' },
        { key: "mileage", translation: 'کارکرد (به کیلومتر)' },
        { key: "loadCapacity", translation: 'ظرفیت بارگیری' },
        { key: "gearbox", translation: 'گیربکس' },
        { key: "enginePower", translation: 'قدرت موتور' },
        { key: "bodyStatus", translation: 'وضعیت بدنه' },
        { key: "tireStatus", translation: 'وضعیت لاستیک' },
        { key: "mechanicalStatus", translation: 'وضعیت مکانیزم' },
        { key: "insuranceStatus", translation: 'وضعیت بیمه' },
        { key: "city", translation: 'شهر' },
        { key: "otherCategory", translation: 'دیگر کاربری' },
        { key: "otherBrand", translation: 'دیگر برند' },
        { key: "otherYearModel", translation: 'دیگر سال ساخت' },
        { key: "otherLoadCapacity", translation: 'دیگر ظرفیت بارگیری' },
        { key: "otherBodyColor", translation: 'دیگر رنگ بدنه' },
        { key: "chassisColor", translation: 'رنگ شاسی' },
        { key: "axelCount", translation: 'تعداد محور' },
        { key: "moreFeatures", translation: 'امکانات بیشتر' },
        { key: "belowMechanizms", translation: 'زیر مکانیزم' },
        { key: "otherTireStatus", translation: 'دیگر وضعیت لاستیک ها' },
        { key: "breakType", translation: 'ترمز' },
        { key: "plateStatus", translation: 'وضعیت کاسه' },
        { key: "otherBodyStatus", translation: 'دیگر وضعیت بدنه' },
        { key: "otherMoreFeatures", translation: 'دیگر امکانات بیشتر' },
        { key: "passangerCapacity", translation: 'تعداد صندلی' },
        { key: "length", translation: 'طول (متر)' },
        { key: "rearSuspension", translation: 'کمک محورهای عقب' },
        { key: "interiorColor", translation: 'رنگ داخلی' },
        { key: "tireCount", translation: 'تعداد لاستیک' },
        { key: "jackCapacity", translation: 'ظرفیت جک' },
        { key: "jackBrand", translation: 'برند جک' },
        { key: "type", translation: 'نوع فروش' },
        { key: "homeNo", translation: 'شماره تماس' },
        { key: "telegramAddress", translation: 'آدرس تلگرام' },
        { key: "whatsAppAddress", translation: 'آدرس واتساپ' },
    ]

    useEffect(() => {
        if (isLoading) {
            props.startFetchVehicleDetails(props.match.params.id)
                .then(({ success, error }) => {
                    if (success) {
                        setLoading(false)
                    }
                    else {
                        setLoading(false)
                    }
                })
        }
    }, [isLoading])

    useEffect(() => {

        if (props.favourites && props.details) {
            setFavoured(props.favourites.includes(props.details.id))
        }
    }, [props.favourites, props.details])

    const settings = {
        arrows: false,
        dots: true,
        infinite: true,
        rtl: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const onFavouriteClicked = (e) => {
        if (isFavoured) {
            props.startRemoveVehicleFromFavourites(props.details.id)
        } else {
            props.startAddVehicleToFavourites(props.details.id)
        }
    }

    const onReportClicked = (e) => {
        props.startReportVehicleAd(props.details.id)
            .then(({ success, error }) => {
                if (success) {
                    setReportDialog(true)
                }
                else {
                }
            })
    }

    const handleCloseReportModal = (e) => {
        setReportDialog(false);
    }

    const renderSlides = () => {
        const slides = props.details.images.length == 0 ? [logo] : props.details.images.map((item) => (item.image))
        if (!slideImages) {
            setSlideImages(slides)
        }
        // const slides = [logo, logo, logo];
        return slides.map((slide, index) => {
            return (
                <div className={props.details.images.length == 0 ? "carousel__slide--no-img" : "carousel__slide"}>
                    <img onClick={onImageClicked.bind(this, index)} className={props.details.images.length == 0 ? "carousel__slide-image--no-img" : "carousel__slide-image"} src={slide} />
                </div>
            );
        });
    }

    const onImageClicked = (idx) => {
        setViewerOpen(true)
        setCurrentImage(idx)
    }

    const onCloseClicked = () => {
        setViewerOpen(false)
    }

    const renderZoomed = () => {
        return isViewerOpen ? (
            <div className="vehicle-detail-popover">
                <span onClick={onCloseClicked} className="pop-close"><i className="material-icons">close</i></span>
                <QuickPinchZoom onUpdate={onUpdate}>
                    <img className="poped-image" ref={imgRef} src={slideImages[currentImage]} />
                </QuickPinchZoom>
            </div>
        ) : undefined
    }

    return (
        <div className="container-sm optimized__d-flex-class flex-column h-100 px-0 vehicle-details">
            {
                isLoading ? (
                    <Loading />
                ) : (
                        <div className="vehicle-details__main-scroll px-0">
                            <Slider {...settings}>
                                {renderSlides()}
                            </Slider>
                            {renderZoomed()}

                            <div className="optimized__d-flex-class flex-column flex-grow-1 pt-3">
                                <div className="optimized__d-flex-class flex-row align-items-center justify-content-between">
                                    <span className="vehicle-details__title px-4">{`${props.details.vehicle.brand.name} ${props.details.vehicle.name}`}</span>
                                    <div className="optimized__d-flex-class flex-row align-items-center px-4">
                                        <span onClick={onReportClicked}><i class="material-icons m-2">warning</i></span>
                                        <span onClick={onFavouriteClicked}><i class={`material-icons m-2 ${isFavoured ? "vehicle-details__icon--active" : ""}`}>star</i></span>
                                    </div>
                                    <ModalComponent
                                        onRequestClose={handleCloseReportModal}
                                        isOpen={reportDialog}>
                                        <div className="dashboard__info-modal d-flex flex-column flex-grow-1">
                                            <span>گزارش شما با موفقیت ثبت شد</span>
                                            <div className="optimized__d-flex-class justify-content-end pt-3">
                                                <button className="btn__close m-0" onClick={handleCloseReportModal}>بستن</button>
                                            </div>
                                        </div>
                                    </ModalComponent>
                                </div>
                                <div className="optimized__d-flex-class flex-row-reverse px-4 justify-content-between align-items-center">
                                    <span className="vehicle-ad__price-type">{props.details.type.name}</span>
                                    {
                                        props.details.type.name !== 'توافقی' ? (
                                            <span className="vehicle-details__sub-title">{`قیمت فروشنده: ${enToFa(Numeral(props.details.price).format('0,0'))} تومان`}</span>
                                        ) : (
                                                <span className="vehicle-details__sub-title">قیمت فروشنده: -</span>
                                            )
                                    }
                                </div>
                                <hr className="vehicle-details__separator mx-3" />
                                <div className="optimized__d-flex-class justify-content-between align-items-center px-4">
                                    <a className="vehicle-details__contact-button ml-3" href={`https://api.whatsapp.com/send?text=http://m.carclick.ir/vehicle/${props.details.id} - ${props.details['vehicle']['name']}`.replace(/[|&;$%@"<>()+,]/g, "")}>اشتراک در واتس‌اپ</a>
                                    <a className="vehicle-details__contact-button mr-3" href={`https://telegram.me/share/url?url=http://m.carclick.ir/vehicle/${props.details.id}&text=${props.details['vehicle']['name']}`}>اشتراک در تلگرام</a>
                                </div>
                                <div className="optimized__d-flex-class justify-content-between align-items-center px-4">
                                    <a className="vehicle-details__contact-button mt-3" href={`tel:${props.details.verifiedPhoneNumber}`}>تماس تلفنی</a>
                                </div>
                                <div className="vehicle-details__sub-bg mt-3 pb-4">
                                    <span className="vehicle-details__table-title py-1">مشخصات خودرو</span>
                                    <div className="vehicle-details__table-container mx-4">
                                        {detailKeys.map((currentKey) => {
                                            return props.details[currentKey['key']] ? (
                                                <>
                                                    <span className="vehicle-details__table-key col-6">{currentKey['translation']}: </span>
                                                    {
                                                        props.details[currentKey['key']]['name'] ? (
                                                            <span className="vehicle-details__table-value col-6">{props.details[currentKey['key']]['name']}</span>
                                                        ) : (
                                                                <span className="vehicle-details__table-value col-6">{currentKey['key'] === "moreFeatures" ? enToFa(props.details[currentKey['key']].replace(/&/g, "، ")) : enToFa(props.details[currentKey['key']])}</span>
                                                            )
                                                    }
                                                </>
                                            ) : undefined
                                        })}
                                        <span className="vehicle-details__table-key col-12 mt-3">توضیحات فروشنده:</span>
                                        <span className="vehicle-details__table-value col-12 text-justify">{enToFa(props.details['description'] || "بدون توضیحات")}</span>
                                        <div className="vehicle-details__warning p-2 mt-3 text-justify">
                                            بدیهی است که کارکلیک هیچگونه مسئولیتی در قبال معامله و نوع پرداخت طرفین ندارد، لذا قبل از انجام معامله، از صحت و سلامت کالا اطمینان حاصل کنید.
                                </div>
                                    </div>
                                    <span className="vehicle-details__title px-4 d-none">آگهی‌های مشابه</span>
                                </div>
                            </div>
                        </div>
                    )
            }
        </div>
    )
}

const mapDispatchToProps = (dispatch) => ({
    startFetchVehicleDetails: (id) => dispatch(startFetchVehicleDetails(id)),
    startAddVehicleToFavourites: (id) => dispatch(startAddVehicleToFavourites(id)),
    startRemoveVehicleFromFavourites: (id) => dispatch(startRemoveVehicleFromFavourites(id)),
    startReportVehicleAd: (id) => dispatch(startReportVehicleAd(id)),
})

const mapStateToProps = (state, props) => ({
    details: state.vehicleAds.detail,
    favourites: state.vehicleConfigs.favouriteVehicleAds
})

export default connect(mapStateToProps, mapDispatchToProps)(VehicleDetails);